/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `secret_token` - Secret Token
 * * `webhook_token` - Webhook Token
 */
export enum TokenTypeEnum {
  SECRET_TOKEN = 'secret_token',
  WEBHOOK_TOKEN = 'webhook_token',
}
